<template>
  <div class="ListButtons">
    <UiIcon
      :title="$t('ListButtons.bulletList')"
      @click="toggleFormat('bulletList')"
      class="ToolbarButton"
      :class="{ 'is-active': isActive.bulletList }"
      value="mdi:format-list-bulleted"
    />

    <UiIcon
      :title="$t('ListButtons.orderedList')"
      @click="toggleFormat('orderedList')"
      class="ToolbarButton"
      :class="{ 'is-active': isActive.orderedList }"
      value="mdi:format-list-numbered"
    />
  </div>
</template>

<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import { UiIcon } from '@/modules/ui/components';

export default {
  components: {
    UiIcon,
  },
  mixins: [useI18n],

  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  methods: {
    toggleFormat(format) {
      switch (format) {
        case 'bulletList':
          return this.editor.chain().focus().toggleBulletList().run();
        case 'orderedList':
          return this.editor.chain().focus().toggleOrderedList().run();
      }
    },
  },

  computed: {
    isActive() {
      return {
        bulletList: this.editor.isActive('bulletList'),
        orderedList: this.editor.isActive('orderedList'),
      };
    },
  },

  i18n: {
    en: {
      'ListButtons.bulletList': 'Bullet list',
      'ListButtons.orderedList': 'Numbered list',
    },
    es: {
      'ListButtons.bulletList': 'Lista de viñetas',
      'ListButtons.orderedList': 'Lista numerada',
    },
    de: {
      'ListButtons.bulletList': 'Aufzählungsliste',
      'ListButtons.orderedList': 'Nummerierte Liste',
    },
    fr: {
      'ListButtons.bulletList': 'Liste à puces',
      'ListButtons.orderedList': 'Liste numérotée',
    },
    it: {
      'ListButtons.bulletList': 'Elenco puntato',
      'ListButtons.orderedList': 'Elenco numerato',
    },
    pt: {
      'ListButtons.bulletList': 'Lista de marcadores',
      'ListButtons.orderedList': 'Lista numerada',
    },
  },
};
</script>